"use strict";
var number = require("./number");
// The `integer` type is just a wrapper for the `number` type. The `number` type
// returns floating point numbers, and `integer` type truncates the fraction
// part, leaving the result as an integer.
var integerType = function integerType(value) {
    var generated = number(value);
    // whether the generated number is positive or negative, need to use either
    // floor (positive) or ceil (negative) function to get rid of the fraction
    return generated > 0 ? Math.floor(generated) : Math.ceil(generated);
};
module.exports = integerType;



//////////////////
// WEBPACK FOOTER
// ./~/json-schema-faker/lib/types/integer.js
// module id = 1335
// module chunks = 1